// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92addde4","453":"51f59096","732":"858c7c43","977":"cfd9f544"}[chunkId] + ".chunk.js";
};